export default __webpack_public_path__ + "static/media/no-table-choice.907119e8.svg";